module.exports = __webpack_public_path__ + "static/media/plus_white.ff631c91.svg";